import { appUrl } from '../runtime'

// Replaces `next/navigation` in the widget build. Routing becomes full-page navigation to
// core's frontend origin (the casino has no Next client router).
export function useRouter() {
  return {
    push: (href: string) => {
      window.location.href = appUrl(href)
    },
    replace: (href: string) => {
      window.location.replace(appUrl(href))
    },
    refresh: () => window.location.reload(),
    back: () => window.history.back(),
    forward: () => window.history.forward(),
    prefetch: () => {},
  }
}

export function useSearchParams(): URLSearchParams {
  return new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '')
}

export function usePathname(): string {
  return typeof window !== 'undefined' ? window.location.pathname : '/'
}
